export default __webpack_public_path__ + "static/media/640_dummy2016-steuerberatung01-mobile-de.d55dcdf4.png";